import { useLocation } from 'react-router-dom';
import { useAppAuth, useAppAuthActions } from '../hooks/useAppAuth';
import TenantSwitcher from '../components/TenantSwitcher';

export default function TenantArchived() {
  const location = useLocation();
  const { user } = useAppAuth();
  const { logout } = useAppAuthActions();
  const tenantName = (location.state as any)?.tenantName || 'This tenant';

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="w-full max-w-md space-y-6 rounded-lg border p-8 shadow-sm">
        <div className="flex justify-center">
          <img src="/static/img/pliable-logo.svg" alt="Pliable" className="h-8" />
        </div>

        <div className="text-center space-y-2">
          <h1 className="text-xl font-semibold">Tenant Archived</h1>
          <p className="text-sm text-muted-foreground">
            <strong>{tenantName}</strong> has been archived and is no longer accessible.
          </p>
        </div>

        {user && (
          <div className="space-y-3">
            <p className="text-sm text-muted-foreground text-center">
              Switch to another account:
            </p>
            <TenantSwitcher />
          </div>
        )}

        <div className="text-center">
          <button
            onClick={() => logout()}
            className="text-sm text-muted-foreground underline hover:text-foreground"
          >
            Log out
          </button>
        </div>
      </div>
    </div>
  );
}
